import bind from '@/login/bind'

bind()
